import ApiSignals, { ApiSignalFetchers } from "@/apis/api_signals"
import { getAssetsUrlWithHttp, getCurrentTagByDomain } from "@/utils/common"
import { createLogger } from "@/utils/logger"
import { computed } from "@preact/signals"
import { isArray, isEmpty, size } from "lodash"

const logger = createLogger("Home Game Signal")

const generatePlaceholderGames = (
    count = 5,
): IndexCacheApiTypes.Fetcher.Result.HomeListGameItem[] => {
    return Array.from({ length: count }, (_, i) => ({
        code: `placeholder_code_${i}`,
        created_at: Date.now(),
        en_name: `Loading...`,
        game_id: `placeholder_${i}`,
        game_type: "0",
        id: `placeholder_id_${i}`,
        img: "", // 可设置 loading 占位图路径
        is_hot: 0,
        is_new: 0,
        maintained: "0",
        online: "0",
        platform_id: "0",
        platform_name: "loading",
        rtp: "",
        sorting: i,
        updated_at: Date.now(),
        updated_name: "",
        updated_uid: "",
        venue_id: "0",
        zh_name: `加载中...`,
    }))
}

const fetchDataIndex = () => {
    return ApiSignalFetchers.fetchDataSignalIndexCache()
}

const dataIndex = computed(() => {
    return ApiSignals.dataSignalIndexCache.value
})

/**
 * @description 首页轮播图数据
 */
const dataBanners = computed(() => {
    if (isArray(dataIndex.value?.top) && dataIndex.value.top.length > 0) {
        return dataIndex.value?.top
    }
    if (isArray(dataIndex.value?.banners) && dataIndex.value.banners.length > 0) {
        return dataIndex.value?.banners
    }
    return [
        {
            id: "0",
            type: 0,
            tags: "",
            url: "",
            link: "/",
            back_color: "#fff",
            state: 0,
            is_delete: 0,
            created_at: 0,
            updated_at: 0,
            updated_uid: "0",
            updated_name: " ",
        },
    ]
})

/**
 * @description 首页导航数据
 */
const dataNav = computed(() => {
    return dataIndex.value?.nav || {}
})

/**
 * @description 首页游戏列表数据
 */
const dataList = computed(() => {
    return isEmpty(dataIndex.value?.list)
        ? {
              ["Hot Games"]: generatePlaceholderGames(5),
              ["Slot"]: generatePlaceholderGames(5),
              ["Live"]: generatePlaceholderGames(5),
              ["Fishing"]: generatePlaceholderGames(5),
              ["Table Game"]: generatePlaceholderGames(5),
              ["Board Game"]: generatePlaceholderGames(5),
          }
        : dataIndex.value?.list
})

/**
 * @description 品牌Logo
 */
const dataLogo = computed(() => {
    if (isArray(dataIndex.value?.logo) && dataIndex.value.logo.length > 0 && dataIndex.value.logo[0]?.url) {
        return getAssetsUrlWithHttp(dataIndex.value.logo[0]?.url)
    }
    const tag = getCurrentTagByDomain()
    switch (tag) {
        case "":
        case "filbet":
            return "brands_logos/logo_filbet_color.webp"
        case "filgame":
            return "brands_logos/logo_filgame_color.webp"
        case "filplay":
            return "brands_logos/logo_filplay_color.webp"
        case "filslots":
            return "brands_logos/logo_filslots_color.webp"
        default:
            return "brands_logos/logo_filbet_color.webp"
    }
})

/**
 * @description 底部公示
 */
const dataBottom = computed(() => {
    return isArray(dataIndex.value?.bottom) && dataIndex.value.bottom.length > 0
        ? dataIndex.value.bottom
        : []
})

/**
 * @description 版本号管理
 */
const dataVersion = computed(() => {
    return isArray(dataIndex.value?.version) && dataIndex.value.version.length > 0
        ? dataIndex.value.version[0]
        : null
})

/**
 * @description 自媒体号
 */
const dataMedia = computed(() => {
    return isArray(dataIndex.value?.media) ? dataIndex.value.media : []
})

export const IndexData = {
    dataMedia,
    dataVersion,
    dataBottom,
    dataLogo,
    dataBanners,
    dataList,
    dataNav,
    fetchDataIndex,
}
